<template>
    <div class="approval_process" style="width: 100%" v-if="props.data && props.data.processTaskList && props.data.processTaskList.length > 0">
      <a-collapse>
        <a-collapse-panel header="审批流程信息" style="margin-bottom: 0;">
          <a-timeline>
              <a-timeline-item>
                <h4>开始</h4>
                <p>提交时间：{{ props.data.processInstance && props.data.processInstance.create_time }}</p>
              </a-timeline-item>
              <a-timeline-item
                  v-for="task in props.data.processTaskList"
                  :key="task.process_task_id"
              >
              <h4 class="item_title">{{ task.processDefinitionNode.name }}</h4>
              <div class="task_item">
                  <p>审批人：{{ task.user && task.user.user_name }}</p>
                  <p>部门：{{ task.depart && task.depart.name }}</p>
                  <p>状态：{{ codeToText(task.state, processState) }}</p>
                  <template v-if="task.state !== 0">
                  <p>
                      结果：
                      <span :style="{ color: task.result === 2 ? 'red' : 'green' }">
                      {{ codeToText(task.result, processResultOptions) }}
                      </span>
                  </p>
                  <p>意见：{{ task.remark }}</p>
                  <p>时间：{{ task.approve_time }}</p>
                  </template>
              </div>
              </a-timeline-item>
              <a-timeline-item><h4>结束</h4></a-timeline-item>
          </a-timeline>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </template>
  
  <script setup>
    import { defineProps, defineEmits, toRefs } from 'vue'
    import { codeToText, constantToOptions } from '@/utils/format'
    import { processResultOptions, processState } from '@/utils/common'
    import { useStore } from 'vuex'
    //初始化
    const props = defineProps({
      data: Object,
    })
    const emit = defineEmits()
    const store = useStore()
    const Enum = toRefs(store.state.common)

  </script>
  
  <style lang="less" scoped>
    .approval_process {
      .item_title,
      p {
        margin: 0;
        padding: 0;
      }
      .task_item {
        padding: 8px;
        border: 1px solid #00000061;
        border-radius: 5px;
        margin-bottom: 6px;
      }
    }
  </style>